export default __webpack_public_path__ + "f9fa649de974f41c1d7eb6ba800b9877.svg";